import React, { useState } from "react";
import { HeaderWrapper, LeftContent, RightContent } from "../StyledComponent";
import { RightContentIconURL } from "../data";
import {
  Accessible,
  AccessibleForward,
  ContrastRounded,
  DownloadForOffline,
  Language,
  LanguageOutlined,
  Search,
  VolumeUp,
} from "@mui/icons-material";
import { Button, Menu, MenuItem } from "@mui/material";
import { LanguageIcon } from "@egovernments/digit-ui-react-components";
import LanguageSelection from "../../LanguageSelection";
import { useTranslation } from "react-i18next";

function Header() {
  const [language, setLanguage] = useState("Select Language");
  const [anchorEl, setAnchorEl] = useState(null);
  const tenantId = Digit.ULBService.getCurrentTenantId() || "up";
  const { t } = useTranslation();
  const handleLanguageChange = async (selectedLang) => {
    const languageCode = selectedLang === "English" ? "en_IN" : "hi_IN";
    setLanguage(selectedLang);
    await Digit.LocalizationService.changeLanguage(languageCode, tenantId);
    handleClose();
  };
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <HeaderWrapper>
      <LeftContent>{t("FASTPAS.HOME.GOV_HEADER.GOVERNMENT_NAME")}</LeftContent>
      <RightContent>
        {/* Icons with margin and color set */}
        {/* <ContrastRounded style={{ marginRight: "10px", color: "#fff", fontSize: "20px" }} />
        <DownloadForOffline style={{ marginRight: "10px", color: "#fff", fontSize: "20px" }} />
        <VolumeUp style={{ marginRight: "10px", color: "#fff", fontSize: "20px" }} />
        <AccessibleForward style={{ marginRight: "10px", color: "#fff", fontSize: "20px" }} /> */}
        <LanguageOutlined style={{ marginRight: "15px", color: "#fff", fontSize: "20px" }} onClick={handleClick} />
        <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
          <MenuItem onClick={() => handleLanguageChange("English")}>English</MenuItem>
          <MenuItem onClick={() => handleLanguageChange("Hindi")}>Hindi</MenuItem>
        </Menu>
        {/* <Search style={{ marginRight: "10px", color: "#fff", fontSize: "20px" }} /> */}
      </RightContent>
    </HeaderWrapper>
  );
}

export default Header;
